import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./global.css"; // global style
import versionTood from '@/libs/versionUpdate'
Vue.config.productionTip = false;

import { message, Modal } from "ant-design-vue";

Vue.prototype.$message = message;
Vue.prototype.$warning = Modal.warning;
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  versionTood.isNewVersion();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
